// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fm-0";
export var animationContainer = "_fm-1";
export var modalContent = "_fm-2";
export var orderName = "_fm-3";
export var refundOption = "_fm-4";
export var refundOptionsContainer = "_fm-5";